import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { Smartphone, Layers, Link2, Landmark, UserCog, Sparkles } from 'lucide-react';
import { ServicesManager } from '@/components/appsettings/ServicesManager';
import { InquiryLinksManager } from '@/components/appsettings/InquiryLinksManager';
import { BankSettings } from '@/components/appsettings/BankSettings';
import { WelcomeSettings } from '@/components/appsettings/WelcomeSettings';
import { Users } from '@/pages/Users';

const TABS = [
  { key: 'welcome', icon: Sparkles, ar: 'الصفحة الترحيبية', en: 'Welcome Screen' },
  { key: 'services', icon: Layers, ar: 'الخدمات', en: 'Services' },
  { key: 'links', icon: Link2, ar: 'روابط الاستعلامات', en: 'Inquiry Links' },
  { key: 'bank', icon: Landmark, ar: 'بيانات البنك', en: 'Bank Details' },
  { key: 'accounts', icon: UserCog, ar: 'حسابات العملاء', en: 'Client Accounts' },
];

export default function AppSettings() {
  const { i18n } = useTranslation();
  const { token } = useAuth();
  const isRTL = i18n.language === 'ar';
  const headers = { Authorization: `Bearer ${token}` };
  const [tab, setTab] = useState('services');

  return (
    <div className="space-y-5" dir={isRTL ? 'rtl' : 'ltr'} data-testid="app-settings-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Smartphone className="w-6 h-6 text-[#D4AF37]" />{isRTL ? 'إعدادات تطبيق الهاتف' : 'Mobile App Settings'}</h1>
        <p className="text-slate-500 text-sm mt-0.5">{isRTL ? 'كل ما يظهر للعميل والمتعامل في التطبيق يُدار من هنا' : 'Everything shown to clients and guests in the app is managed here'}</p>
      </div>
      <div className="flex gap-1 p-1 bg-slate-100 rounded-xl w-fit flex-wrap" data-testid="app-settings-tabs">
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`tab-${t.key}`}
            className={`flex items-center gap-1.5 px-4 h-9 rounded-lg text-sm font-medium transition-all ${tab === t.key ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-800'}`}>
            <t.icon className="w-4 h-4" />{isRTL ? t.ar : t.en}
          </button>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 p-5">
        {tab === 'welcome' && <WelcomeSettings isRTL={isRTL} headers={headers} />}
        {tab === 'services' && <ServicesManager isRTL={isRTL} headers={headers} />}
        {tab === 'links' && <InquiryLinksManager isRTL={isRTL} headers={headers} />}
        {tab === 'bank' && <BankSettings isRTL={isRTL} headers={headers} />}
        {tab === 'accounts' && <Users />}
      </div>
    </div>
  );
}
